export enum BankIdAuthType {
	Login = "login",
	Register = "register",
	StepUp = "stepup",
}
